









import Vue from 'vue';
import CustomerFilterDisplayBox from '../../../../mass/components/mpgroup/CustomerFilterDisplayBox.vue';

export default Vue.extend({
  props: {
    customerFilter: {
      type: Object,
      default: null,
    },
    customerGroups: {
      type: Array,
      default: null,
    },
    memberCards: {
      type: Array,
      default: null,
    },
  },
  components: {
    CustomerFilterDisplayBox,
  },
});
